import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import AppProviders from "./AppProviders.tsx";
import "./index.css";

const rootEl = document.getElementById("root")!;

const tree = (
  <AppProviders>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AppProviders>
);

// In the SSG production build the route HTML is prerendered, so we hydrate the
// existing markup. In `vite dev` the #root is empty, so we create a fresh root
// instead (hydrating an empty container would throw hydration mismatch errors).
// The provider tree + router here must match entry-server.tsx for hydration.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, tree);
} else {
  createRoot(rootEl).render(tree);
}
